import React from "react";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/home/Footer";
import {
  AboutSection,
  ServicesSection,
  TeamSection,
  PartnersSection,
  FindUsSection,
} from "../components/home/SectionBlocks";
import { Seo } from "../components/seo/Seo";
import { ASSETS } from "../constants/assets";

interface SectionPageFrameProps {
  path: string;
  titleKey: string;
  descriptionKey: string;
  children: React.ReactNode;
}

function SectionPageFrame({
  path,
  titleKey,
  descriptionKey,
  children,
}: SectionPageFrameProps): React.ReactElement {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Seo path={path} titleKey={titleKey} descriptionKey={descriptionKey} />
      <Header logoImageSrc={ASSETS.logo} logoImageAlt="BalkanFinXpert" />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function AboutPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/about-us"
      titleKey="seo.about.title"
      descriptionKey="seo.about.description"
    >
      <AboutSection />
    </SectionPageFrame>
  );
}

export function ServicesPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/services"
      titleKey="seo.services.title"
      descriptionKey="seo.services.description"
    >
      <ServicesSection />
    </SectionPageFrame>
  );
}

export function TeamPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/team"
      titleKey="seo.team.title"
      descriptionKey="seo.team.description"
    >
      <TeamSection />
    </SectionPageFrame>
  );
}

export function PartnersPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/partners"
      titleKey="seo.partners.title"
      descriptionKey="seo.partners.description"
    >
      <PartnersSection />
    </SectionPageFrame>
  );
}

export function FindUsPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/find-us"
      titleKey="seo.findUs.title"
      descriptionKey="seo.findUs.description"
    >
      <FindUsSection />
    </SectionPageFrame>
  );
}

export function ContactsPage(): React.ReactElement {
  return (
    <SectionPageFrame
      path="/contact"
      titleKey="seo.contact.title"
      descriptionKey="seo.contact.description"
    >
      <FindUsSection />
    </SectionPageFrame>
  );
}
